export default __webpack_public_path__ + "static/media/Group 88.6e70f75b.svg";